export interface RiskGroup {
  id: number;
  name: string;
}

export interface RiskPhase {
  id: number;
  name: string;
}

export interface RiskConsequence {
  id: number;
  name: string;
}

export interface RiskAssessment {
  impact: number;
  people_count: number;
  duration: number;
  probability: number;
  detectability: number;
}

export interface RiskMitigation {
  id: string;
  type: string;
  impact: number;
  version: number;
  duration: number;
  pictogram: string;
  left_risk: string;
  probability: number;
  description: string;
  people_count: number;
  detectability: number;
  applied_standards: string[];
  reasoning?: string;
}

export type Risk = RiskAssessment & {
  id: string;
  personal: string;
  group_id: GroupId;
  phase_id: string;
  created_at: string;
  resource_id: string;
  description: string;
  readable_name?: string;
  last_updated?: string;
  is_blueprint?: boolean;
  consequence_id: string;
  protection_goal: string;
  blueprint_name?: string;
  fully_mitigated: boolean;
  assessment: RiskAssessment;
  mitigations: RiskMitigation[];
  blueprint_description?: string;
  reasoning?: string;
};

export interface RiskGroupping {
  id: string;
  label: string;
  description: string;
  members: string[];
}

export type GroupId = keyof typeof GroupTypes;

export enum GroupTypes {
  "noise",
  "mechanical",
  "electrical",
  "thermal",
  "vibration",
  "radiation",
  "material",
  "ergonomic",
  "placement",
  "it",
}

export interface RiskRouteParams {
  projectId: string;
}
